import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultButton, Modal, PrimaryButton, Dropdown } from '@fluentui/react';
import General from '../../tests/general';
import * as Api from '../../../api/src';
import ModalHeader from '../../../control/modalHeader';
import styled from 'styled-components';
const DivContent = styled.div`
  padding: 0 22px 0 22px !important;
  .page-content {
    margin: 0;
    padding: 0 0 20px 0;
  }
`;
export interface ModalAddUserProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  Item: Api.TestDto | null;
}
const ModalViewTest = ({ IsOpen, onCloseModal, Item }: ModalAddUserProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);

  React.useEffect(() => {
    if (IsOpen && Item) {
      SetIsShow(IsOpen);
    }
  }, [IsOpen]);

  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={t('Test')}
        onCloseModal={() => {
          onClose();
        }}
      />
      <DivContent className={'modal-content'} style={{ width: 800 }}>
        <div className="ms-Grid" dir="ltr">
          <General isView={true} Item={Item || {}} RefeshTab={() => {}}></General>
        </div>
      </DivContent>
      <div className={'modal-footer'}>
        <DefaultButton
          className={'margin-left-10'}
          onClick={() => {
            onClose();
          }}
        >
          {t('Close')}
        </DefaultButton>
      </div>
    </Modal>
  );
};
export default ModalViewTest;
